import { render, staticRenderFns } from "./plan-form.vue?vue&type=template&id=7fb75e72&"
import script from "./plan-form.vue?vue&type=script&lang=js&"
export * from "./plan-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports